import React, {useState, useEffect} from 'react';
import {AppUser} from "models/app";
import {ProprietarioObject} from "models/Proprietario";
import {FormDefinition} from "lib/forms";
import {useForm} from "lib/formHook";
import {filterProprietariosByTel} from "./controller";
import {ModalContent, ModalFooter} from "components/Modal";
import Input from "components/forms/Input";
import BuscaResultados from "./BuscaResultados";
import {IonButton} from "@ionic/react";
import {FazendaIndexProprietario} from "../../../lib/DataHooks/fazendas";

interface BuscaTelefoneProps {
  user: AppUser;
  proprietarios: ProprietarioObject[];
  onSelect?: (prop: ProprietarioObject) => void;
  onNotfound: (telefone: string) => void;
  onClickBack: () => void;
  initialTelefone?: string;
  indexProprietarios?: FazendaIndexProprietario;
}

const formBuscaTelefone: FormDefinition = {
  telefone: {name: 'telefone', label: 'Telefone do proprietário', type: "telefone", required: false},
};

const BuscaTelefone: React.FC<BuscaTelefoneProps> = (props) => {
  const {proprietarios, user, onSelect, onNotfound,
    onClickBack, initialTelefone, indexProprietarios} = props;
  const [filtered, setFiltered] = useState(false);
  const [found, setFound] = useState<ProprietarioObject[]>([]);
  const {formState, setFieldValue} = useForm(formBuscaTelefone, {telefone: initialTelefone});
  const defaultMessage = 'Digite o telefone completo para prosseguir.';
  const [message, setMessage] = useState(defaultMessage);
  const telefone = formState.telefone.value;
  const isValid = !!telefone && !formState.telefone.hasError;
  const [addEnabled, setAddEnabled] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // console.log('BuscaTelefone mounting');
    setMounted(true);
    return () => {
      // console.log('BuscaTelefone unmounting');
      setMounted(false);
    };
  }, []);

  // onChange telefone
  useEffect(() => {
    if (mounted) {
      // console.log('CHANGED TELEFONE', telefone, isValid);
      if (telefone) {
        if (!isValid) {
          setMessage('O telefone informado não é válido.');
          setAddEnabled(false);
        }
      } else {
        setMessage(defaultMessage);
      }
      setFiltered(false);
    }
  }, [isValid, telefone, mounted]);

  // search
  useEffect(() => {
    if (isValid && !filtered) {
      // console.log('searchTelefone', telefone);
      const {found: _found} = filterProprietariosByTel(proprietarios, telefone);
        setFound(_found);
        setFiltered(true);
    }
  }, [filtered, telefone, proprietarios, isValid]);

  // onSearch
  useEffect(() => {
    if (filtered) {
      if (found.length === 0) {
        setMessage('Confirme o telefone inserido e clique em Prosseguir para completar o cadastro.');
        setAddEnabled(true);
      } else {
        if (!!onSelect)
          setMessage('O telefone informado já está em uso, selecione o proprietário acima ou altere o telefone.');
        else
          setMessage('O telefone informado já está em uso, você pode adicionar uma Fazenda ou usar este proprietário diretamente através da seção Fazendas.');
        setAddEnabled(false);
      }
    }
  }, [found, filtered, onSelect]);

  return (
    <>
      <ModalContent>
        <div className="app-form-step-title">
          1. Cadastro do proprietário
        </div>
        <div className="text-sm opacity-75">
          Antes de completar o cadastro digite o telefone abaixo.
        </div>

        <div>
          <Input
            definition={formBuscaTelefone.telefone}
            onChange={setFieldValue}
            state={formState.telefone}
          />
        </div>

        {filtered && found.length > 0 &&
          <div className="mt-8 flex-grow">
            <BuscaResultados
              user={user}
              found={found}
              onSelect={onSelect}
              indexProprietarios={indexProprietarios}
            />
          </div>
        }
      </ModalContent>

      <ModalFooter
        message={message}
      >
        <div className="flex items-center gap-4 justify-between">
          <IonButton
            color="light"
            onClick={onClickBack}
          >
            Voltar
          </IonButton>
          <IonButton
            onClick={() => onNotfound(telefone)}
            disabled={!addEnabled}
          >
            Prosseguir
          </IonButton>
        </div>
      </ModalFooter>
    </>
  );
}

export default BuscaTelefone;
